import { getAnonId } from '@/utils/anonId';
import { validateEnv } from '@/utils/validateEnv';
import { initFlagsmith as initFlagsmithBase } from '@resolve_medical_bills/flagsmith/react';
import { FALLBACK_FLAGS } from './fallback';

export const initFlagsmith = (): Promise<void> =>
  initFlagsmithBase({
    environmentID: validateEnv().VITE_FLAGSMITH_TOKEN,
    identity: getAnonId(),
    cacheFlags: true,
    // Outage mode: don't hit the disabled Flagsmith API at all.
    // preventFetch → no flag fetch/retry; analytics off → no polling POSTs.
    // Flags come from defaultFlags below. Revert both once the account is back.
    preventFetch: true,
    enableAnalytics: false,
    defaultFlags: FALLBACK_FLAGS,
  });
